import get from 'lodash.get'

export const getQueryString = (field, url) => {
  const href = url ? url : window.location.href,
    reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i'),
    string = reg.exec(href)
  return string ? string[1] : null
}

export const triggerQualtrics = (searchString) => {
  const queryParameterValue = getQueryString('flow', searchString)
  if (queryParameterValue !== -1) {
    const paypal = get(window, 'PAYPAL', undefined)
    if (typeof paypal !== 'undefined' && paypal.analytics) {
      paypal.analytics.reloadQualtrics(`privacynodeweb-${queryParameterValue}`)
    }
  }
}
